import React from 'react';

import styles from './ServiceCategorySelector.module.scss';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import { FieldError } from '@spike/model';
import { getErrorMessage } from './Validations';

interface ServiceCategorySelectorProps {
    selectedCategories: {
        grooming: boolean;
        daycare: boolean;
        boarding: boolean;
    };
    errors: Array<FieldError>;
    onUpdateCategories: (selectedCategories: { grooming: boolean; daycare: boolean; boarding: boolean }) => void;
}

export const ServiceCategorySelector: React.FC<ServiceCategorySelectorProps> = ({
    selectedCategories,
    errors,
    onUpdateCategories
}) => {
    const handleCategoryChange = (category: keyof typeof selectedCategories, checked: boolean) => {
        onUpdateCategories({
            ...selectedCategories,
            [category]: checked
        });
    };

    return (
        <div className={styles.section}>
            <Label
                error={getErrorMessage(errors, 'category')}
                required
            >
                {getErrorMessage(errors, 'category').trim()!
                    ? getErrorMessage(errors, 'category')
                    : 'Select Service Category'}
            </Label>
            <Label className={styles.sectionDescription}>
                Choose which services require an eval—pets that pass can book appointments.
            </Label>

            <div className={styles.categoryCheckboxes}>
                <Checkbox
                    label="Grooming"
                    checked={selectedCategories.grooming}
                    onChange={checked => handleCategoryChange('grooming', checked)}
                />
                <Checkbox
                    label="Daycare"
                    checked={selectedCategories.daycare}
                    onChange={checked => handleCategoryChange('daycare', checked)}
                />
                <Checkbox
                    label="Boarding"
                    checked={selectedCategories.boarding}
                    onChange={checked => handleCategoryChange('boarding', checked)}
                />
            </div>
        </div>
    );
};

export default ServiceCategorySelector;
